export default function extractArrayFromQuery(query, param) {
  if (query[param]) {
    return query[param].split(',').map(id => Number(id));
  }

  return [];
}
